import api from '../../services/api';
import { useMutation } from "@tanstack/react-query";
import { success } from "../global/ToastAlert";
import { useGetVendorId } from "../global/User";
import { useParams } from 'react-router-dom';

export const useSentInvitations = () => {
    const vendorId = useGetVendorId();
    const postData = async ({data:postData, message=null, show=true}) => {
        const { data } = await api.post(`/invitations/?vendorId=${vendorId}`, postData);
        if(show) success(message);
        return data;
    };

    return useMutation(postData);
};

export const useUnsubscribeInvitations = () => {
    const { invitationId } = useParams();
    const postData = async () => {
        const { data } = await api.post(`/invitations/${invitationId}/unsubscribe`, postData);
        return data;
    };

    return useMutation(postData);
};


